import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-point",
  "use": "icon-point-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-point\"><path d=\"M512 512m-134.037736 0a134.037736 134.037736 0 1 0 268.075472 0 134.037736 134.037736 0 1 0-268.075472 0Z\" p-id=\"41011\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol